import gql from 'graphql-tag'

export default gql`
mutation ($resource: String!, $slug: String!) {
  startDownload(resource: $resource, slug: $slug, extension: "csv")
}
`
